class ScriptService {
  public load(url: string, onLoad: () => void) {
    if (this.scriptExists(url)) {
      onLoad();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onerror = this.hadleError;
    if (onLoad) {
      script.onload = () => onLoad();
    }

    document.getElementsByTagName('head')[0].appendChild(script);
    script.src = url;
  }

  private scriptExists(url: string) {
    const scripts = document.getElementsByTagName('script');
    const numScripts = scripts?.length || 0;
    console.debug(`${numScripts} scripts found.`);
    let exsits = false;
    for (let i = 0; i < numScripts; i++) {
      console.debug(`Script src: ${scripts.item(i).src}`)
      if (scripts.item(i).src === url) {
        exsits = true;
        break;
      }
    }

    return exsits;
  }
  private hadleError(source: string) {
    throw new URIError(`The script ${source} didn't load correctly.`);
  }
}

export default new ScriptService();
